import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFoundView.css'

import { Divider, Button } from 'antd';

const NotFoundView = () => {

    const navigate = useNavigate();

    const goToHome = () => {
        navigate('/');
    };

    return <div className="notFoundView-container">
        <span className='title-NotFound'>Página no encontrada</span>
        <span className='title-404'>Error 404</span>
        <Divider></Divider>
        <Button type="link" onClick={goToHome} >Regresar al inicio</Button>
        {/* <p className='mainTitle'>404</p>
        <p className='mainTitle'>Página no encontrada</p>
        <p className='mainTitle'>Página no encontrada</p> */}
    </div>
}

export default NotFoundView;